import { Directive, ElementRef, Renderer2 } from '@angular/core';

/**
 * PasswordViewerDirective exposes and stores the state of password visibility for an input element
 */
@Directive({
  selector: '[appPasswordViewer]',
  exportAs: 'passwordViewer',
  standalone: true
})
export class PasswordViewerDirective {
  private _visible = false;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2
  ) {}

  /**
   * Get the current visibility state
   */
  get visible(): boolean {
    return this._visible;
  }

  /**
   * Toggle the password visibility
   */
  toggle(): void {
    this._visible = !this._visible;
    const inputType = this._visible ? 'text' : 'password';
    this.renderer.setAttribute(this.el.nativeElement, 'type', inputType);
  }
}
